import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const TOKEN_KEY = "snappay_admin_token";
const USER_KEY = "snappay_admin_user";

export const adminApi = axios.create({
  baseURL: `${BACKEND_URL}/api/admin`,
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err?.response?.status === 401) {
      logout();
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUser() {
  return localStorage.getItem(USER_KEY);
}

export function isAuthed() {
  return Boolean(getToken());
}

export async function login(username, password) {
  const { data } = await adminApi.post("/login", { username, password });
  localStorage.setItem(TOKEN_KEY, data.access_token);
  localStorage.setItem(USER_KEY, data.username);
  return data;
}

export function logout() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function downloadCsv(path, filename) {
  const token = getToken();
  return fetch(`${BACKEND_URL}/api/admin${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then(async (r) => {
      if (!r.ok) throw new Error("Download failed");
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    });
}
